import React from "react";
import Image from "../../../elements/Image";
import { classNames } from "../../../../helpers/classNames";
import IconImageUpload from "../../../../assets/images/icon-image-upload.svg";
import IconCropRotate from "../../../../assets/images/icon-crop-rotate.svg";
import IconDraw from "../../../../assets/images/icon-draw.svg";
import IconPaperPlane from "../../../../assets/images/icon-paper-plane.svg";
import ImagePersonalize01 from "../../../../assets/images/image-personalize-01.webp";
import ImagePersonalize02 from "../../../../assets/images/image-personalize-02.webp";
import ImagePersonalize03 from "../../../../assets/images/image-personalize-03.webp";
import ImagePersonalize04 from "../../../../assets/images/image-personalize-04.webp";
import useFetch from "../../../../hooks/useFetch";
import { faqListFont } from "../../../../services/faqService";
import { useBanner } from "../../../../providers/BannerProviders";

const HowItWorksPageContent = () => {
  const { data } = useBanner();
  const {
    data: howitworksdata,
    isLoading,
    error,
  } = useFetch({
    dependencies: ["faqListFront"],
    fetchFunction: async () => {
      const res = await faqListFont({ type: "howItWork" });
      if (res?.docs?.status === 200) {
        return res?.docs?.data || [];
      }
      return [];
    },
  });
  // const howitworksdata = [
  //   {
  //     _id: 1,
  //     name: "Upload Your Photos",
  //     image: ImagePersonalize01,
  //     icon: IconImageUpload,
  //     description: "Start by uploading the photos you want to transform into coloring pages. Our system accepts various image formats, ensuring your memories can easily became art."
  //   },
  //   {
  //     _id: 2,
  //     name: "Crop and Arrange",
  //     image: ImagePersonalize02,
  //     icon: IconCropRotate,
  //     description: "Once uploaded, you can crop and arrange your photos to fit perfectly within the coloring book pages. This step allows you to customize the layout and focus on the most important parts of your images."
  //   },
  //   {
  //     _id: 3,
  //     name: "Line Art Review",
  //     image: ImagePersonalize03,
  //     icon: IconDraw,
  //     description: "Review the line art generated from your photos. This is your chancce to ensure the details are captured just right before finalizing your ccoloring book."
  //   },
  //   {
  //     _id: 4,
  //     name: "Submit Your Design",
  //     image: ImagePersonalize04,
  //     icon: IconPaperPlane,
  //     description: "Happy with your design? Submit it, and we'll take care of the rest. Your personalized coloring book will be printed and shipped directly to you, ready for hours of creative fun."
  //   },
  // ]
  const homeBanner = data?.data?.find((item) => item?.slug === "howitworks-1748585734840");
  return (
    <>
      <section className="relative min-h-screen py-24 overflow-hidden bg-md-pink-light-2">
        <div className="relative w-full px-4 sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
          <div className="space-y-24">
            <div className="space-y-6 text-center">
              <h2 className="text-5xl 3xl:text-6xl font-semibold tracking-tight text-md-dark" dangerouslySetInnerHTML={{ __html: homeBanner?.title }}></h2>
              <div className="text-2xl 3xl:text-3xl tracking-wide text-neutral-500 max-w-3xl 3xl:max-w-5xl mx-auto leading-snug" dangerouslySetInnerHTML={{ __html: homeBanner?.description }}></div>
            </div>
            {howitworksdata?.length > 0 && (
              <div className="relative space-y-40 3xl:space-y-60">
                {howitworksdata?.map((item, index) => (
                  <div className={classNames("group flex items-center gap-1 md:gap-20", index % 2 === 0 ? "flex-row" : "flex-row-reverse")}>
                    <div className="flex-shrink flex-grow max-w-[calc(50%-40px)] space-y-4 3xl:space-y-6">
                      <div className="w-16 aspect-square flex">
                        <Image src={item?.icon?.url} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"object-cover"} />
                      </div>
                      <h2 className="text-3xl 3xl:text-4xl font-semibold text-md-dark">{parseInt(index + 1) + ". " + item?.title}</h2>
                      <div className="text-xl 3xl:text-2xl text-neutral-500 tracking-wide">{item?.description}</div>
                    </div>
                    <div className="flex-shrink flex-grow max-w-[calc(50%-20px)]">
                      <div className="w-full aspect-[3/2] rounded-3xl transition-all duration-300 shadow-md group-hover:shadow-xl shadow-md-pink/10 group-hover:shadow-md-pink/10 flex overflow-hidden">
                        <Image src={item?.image?.url} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"object-cover"} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default HowItWorksPageContent;
